<template>
  <div
    class="container px-4 xl:px-0 w-full mt-6 md:mt-0 w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6"
  >
    <t-card-sceleton class="" />
    <t-card-sceleton class="!hidden sm:!block" />
    <t-card-sceleton class="!hidden xl:!block" />
  </div>
</template>
